<template>
  <div class="screen-tab-status-footer-loader">
    <div class="screen-tab-item-group">
      <div class="screen-tab-item">
        <div class="value">
          <v-skeleton-loader class="progress-loader" type="text" />
        </div>
        <div class="label">Total Progress</div>
      </div>
      <div class="screen-tab-item">
        <div class="value">
          <v-skeleton-loader class="text-loader" type="text" />
        </div>
        <div class="label">Votes By You Today</div>
      </div>
      <div class="screen-tab-item">
        <div class="value">
          <v-skeleton-loader class="text-loader" type="text" />
        </div>
        <div class="label">Total Votes By You</div>
      </div>
    </div>
    <div class="screen-tab-item-group">
      <div class="screen-tab-item">
        <div class="value">
          <v-skeleton-loader class="text-loader" type="text" />
        </div>
        <div class="label">Votes To Train</div>
      </div>
      <div class="screen-tab-item">
        <div class="value">
          ~
          <v-skeleton-loader class="text-loader" type="text" />
        </div>
        <div class="label">Relevant Remaining</div>
      </div>
      <stopping-criteria-help-button />
    </div>
  </div>
</template>

<script>
import StoppingCriteriaHelpButton from './StoppingCriteriaHelpButton';

export default {
  name: 'ScreenTabStatusFooterSkeletonLoader',
  components: {
    StoppingCriteriaHelpButton,
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/main.sass';

.screen-tab-status-footer-loader {
  @extend .d-flex,
    .justify-space-between,
    .align-center,
    .px-6,
    .py-4;

  background-color: map-get($grey, 'lighten-5');
  border-top: 1px solid map-get($grey, 'lighten-2');

  .screen-tab-item-group {
    @extend .d-flex, .align-center;
    gap: 24px;
  }

  .screen-tab-item {
    display: grid;
    grid-template-rows: 1fr 1fr;
    gap: 4px;

    @extend .grey--text, .text--darken-2;

    .value {
      @extend .d-flex, .align-center;
      gap: 8px;

      @extend .font-weight-bold;
      font-size: 14px;
    }
    .label {
      @extend .font-weight-light;
      font-size: 10px;
    }
  }

  .total-progress-breakdown {
    width: 172px;
  }

  .text-loader {
    width: 40px;
  }

  .progress-loader {
    width: 172px;
  }
}
</style>

<style lang="scss">
.screen-tab-status-footer-loader {
  .v-skeleton-loader__text {
    margin-bottom: 0px !important;
  }
}
</style>
